import { ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import useHover from 'src/hooks/useHover'
import { cn } from 'src/lib/cn'
import useSidebarStore from 'src/stores/useSidebarStore'
import HtmlProps from 'src/types/HtmlProps'

const DELAYED_HOVER_DELAY = 100

interface SidebarContainerProps extends HtmlProps<HTMLDivElement> {
  children: ReactNode
}

const SidebarContainer = ({ children, className, ...divProps }: SidebarContainerProps) => {
  const { isOpen: isSidebarOpen, searchInputFocusedId, toggle } = useSidebarStore()
  const { pathname } = useLocation()
  const { hoverProps, delayedHover, isHovered, leaveHover } = useHover({
    mouseLeaveDelay: DELAYED_HOVER_DELAY,
  })

  const isOpen = isSidebarOpen || searchInputFocusedId !== null

  useEffect(() => {
    toggle(isHovered || delayedHover)
  }, [delayedHover, isHovered])

  useEffect(() => {
    leaveHover()
  }, [pathname])

  return (
    <aside
      data-testid="sidebar-container"
      className={cn(
        'top-navbar-height border-geyser w-sidebar-closed-width h-screen-navbar-height fixed z-35 flex flex-col justify-between overflow-hidden border-r bg-white transition-all ease-in',
        {
          'w-sidebar-opened-width ease-out': isOpen,
        },
      )}
      {...hoverProps}
      {...divProps}
    >
      {children}
    </aside>
  )
}

export default SidebarContainer
